/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  passwordSync(id) {
    return axios.post(`${this.url}/${id}/password_sync`);
  }
}

export default new Agents();
